import {Component, OnInit} from '@angular/core';
import {LookupService} from "../lookup.service";
import {ViewManagerService} from "../../../services/view-manager.service";
import {ChannelDefinition} from "../../../model/channels.model";

@Component({
  selector: 'admin-lookup-scoring',
  templateUrl: './scoring.component.html',
  styleUrls: ['./scoring.component.css']
})
export class AdminLookupScoringComponent implements OnInit {

  constructor(
    private singleService: LookupService,
    private viewManager: ViewManagerService
  ) {
  }

  ngOnInit() {
    this.singleService.load("cdd", "api")
  }

  get definition(): ChannelDefinition {
    return this.singleService.definition;
  }

  show() {
    return this.singleService.channels.length > 0;
  }

  get results() {
    return this.singleService.rulesResult;
  }

  showResults() {
    return this.results && this.results.length > 0;
  }

  lookup() {
    this.singleService.rules();
  }

  reset() {
    this.singleService.reset("cdd", "api");
  }

  report() {
    this.singleService.report();
  }

  refine() {
    this.singleService.refine();
  }

}
